import { render } from "./ModalSubCategoryModifier.vue?vue&type=template&id=5d41fb70&scoped=true"
import script from "./ModalSubCategoryModifier.vue?vue&type=script&lang=js"
export * from "./ModalSubCategoryModifier.vue?vue&type=script&lang=js"

import "./ModalSubCategoryModifier.vue?vue&type=style&index=0&id=5d41fb70&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d41fb70"]])

export default __exports__